import SequenceGameList from './SequenceGameList.vue';
import SequenceGame from './SequenceGame.vue';

export default {
  SequenceGameList,
  SequenceGame,
};
